import { useMutation } from "@tanstack/react-query";
import api from "../../services/api";
import { useQueryClient } from "@tanstack/react-query";

export const useRoleUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({id, body}) => {
      const res = await api.put(`/roles/update/${id}`, body );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["viewroles"]);
    },
  });
};

